import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArtDirection = makeShortcode("ArtDirection");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Logo`}</h1>
    <PageDescription mdxType="PageDescription">
      <p>{`Das Logo symbolisiert ein Zeichen, das ein Subjekt repräsentiert.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Überblick</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Formartierung</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Code</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Inhalt</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Referenzen</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Feedback</AnchorLink>
    </AnchorLinks>
    <h2>{`Überblick`}</h2>
    <p>{`Das Logo ist eine Zeichen für die Repräsentation eines Subjekts, wie Unternehmen, Organisation oder ein Produkt. Das Logo besteht dabei aus einer Text, dass aus zwei Varianten besteht`}</p>
    <h4>{`Wann zu verwenden`}</h4>
    <p>{`Das Logo ist für die repräsentation eines Subjektes zu verwenden.`}</p>
    <h3>{`Varianten`}</h3>
    <p>{`Für das Logo stehen zwei Varianten zur Verfügung`}</p>
    <Row mdxType="Row">
      <Column colLg={12} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "835px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "51.388888888888886%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABCcAAAQnAEmzTo0AAAAgklEQVQoz82SQQqAIBBFu/+VwlskboJ2grtqERLN/DRKrMwWITQgzxF5ftEKmWLmwHieKNrZVWWExyZPptDnhJ5EdPS0M0p4PXmT4CZMpXT9Q8KlB6bGcXxNaIyBlBLW2pDQjYtw1sBQA7aNljkpVEpBCAGtdUJY7MofH+Wc8K//cAXpJxel51f+lgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Button variants",
            "title": "Button variants",
            "src": "/static/11b519c6b6922caa4c87512ee8ab248f/e6414/logo-variants.png",
            "srcSet": ["/static/11b519c6b6922caa4c87512ee8ab248f/7fc1e/logo-variants.png 288w", "/static/11b519c6b6922caa4c87512ee8ab248f/a5df1/logo-variants.png 576w", "/static/11b519c6b6922caa4c87512ee8ab248f/e6414/logo-variants.png 835w"],
            "sizes": "(max-width: 835px) 100vw, 835px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Variant`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Purpose`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Primary`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Das primäre Logo wird mit der Textfarbe in Orange (#FFCC00) versehen`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Secondary`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Das sekundäre Logo besteht aus einem Schwarz (#000) Text`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Formartierung`}</h2>
    <h3>{`Anatomy`}</h3>
    <p>{`Das Logo besteht aus einem Text.`}</p>
    <ArtDirection mdxType="ArtDirection">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "295px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "96.52777777777779%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA4UlEQVQ4y+2TTQrCMBCFczJBz+BOvIpU1/UUduEx7MalLgsFK2JbpepGENFk8rTG/liJolRw0cAwA5P5eJmZMJR8WAX8DVBKmfp8/BEwKSAicH6GECLJqJyk+JIyVfBeYVEFkcjqHy9qoSwrppt3XRftVhO2PcJs5iEIfKXytAb47hmqA3LOb940+2CMoVGvYWANMXfHwN4C+R0gMIDD5A4stEDXwyiKYHR7cBwHYbjCdhMCYgl59IDT4gqcAucoU6kDvpqk/GZt8usRPz/uabo2Mo5JM2lZfT3VhNLs/xVeAIeC2B8IFtZzAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "ArtefactCard anatomy",
          "title": "ArtefactCard anatomy",
          "src": "/static/236dc0c2fb79d8c01a73cd506279ea48/ba02f/logo-anatomy.png",
          "srcSet": ["/static/236dc0c2fb79d8c01a73cd506279ea48/7fc1e/logo-anatomy.png 288w", "/static/236dc0c2fb79d8c01a73cd506279ea48/ba02f/logo-anatomy.png 295w"],
          "sizes": "(max-width: 295px) 100vw, 295px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </ArtDirection>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Text`}</strong></li>
    </ol>
    <h2>{`Code`}</h2>
    <h3>{`Dokumentation`}</h3>
    <p>{`Das folgende Storybook zeigt das Logo in einer Live Demo. Des Weiteren kann in dieser Testumgebung das Logo mit verschiedenen Variante getestet werden.`}</p>
    <Row className="resource-card-group" mdxType="Row">
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
  <ResourceCard subTitle="React Dokumentation" actionIcon="launch" aspectRatio="2:1" href="https://storybook-cranachdesign.netlify.app/?path=/story/atoms-logo--primary" mdxType="ResourceCard">
  </ResourceCard>
      </Column>
    </Row>
    <h3>{`Code`}</h3>
    <p>{`Logo mit Standardwerten`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javaScript",
        "metastring": "path=CodeSandbox src=https://gatsby-theme-carbon.now.sh",
        "path": "CodeSandbox",
        "src": "https://gatsby-theme-carbon.now.sh"
      }}>{`
<Logo />


`}</code></pre>
    <p>{`Beispiel: Logo mit der Übergabe aller möglichen props`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javaScript",
        "metastring": "path=CodeSandbox src=https://gatsby-theme-carbon.now.sh",
        "path": "CodeSandbox",
        "src": "https://gatsby-theme-carbon.now.sh"
      }}>{`
<Logo
  primary={false}
  logoTitle={'cranach digital archive_'}
/>

`}</code></pre>
    <h4>{`Props`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Optionen`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`logoTitle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`cda_`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Beschriftung des Logos`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`primary`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`bool`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`true`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode>{`, `}<inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Angabe über die Logo-Variante`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Live Demo`}</h3>
    <h2>{`Inhalt`}</h2>
    <h4>{`Label`}</h4>
    <p>{`Der Logo-Inhalt bzw. Text soll die Beschriftung des Unternehmens, Organisation oder Produktes tragen`}</p>
    <h2>{`Feedback`}</h2>
    <p>{`Helfe uns um diese Komponente/Pattern zu verbessern, indem sie Feedback geben, fragen stelle oder andere Kommentare auf `}<a parentName="p" {...{
        "href": "https://github.com/cranach-design-system/cranach-design/issues/new?assignees=&labels=&template=website-feedback.md&title=Website+feedback"
      }}>{`Github`}</a>{` hinterlassen.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      